import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';

const publishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  'pk_live_51RQZnF2N79RTloF3hOSgBRB6vYvOUfzXMRAjSxFw4dVoWgsAZuyhM4IIkibVVUwdBAW9GdaezObA4FbPXaOFza7700pCzdDx8W';
const apiBase = (process.env.REACT_APP_API_URL || window.location.origin).replace(/\/$/, '');
const stripePromise = loadStripe(publishableKey);

const BuyButton = ({ level, subject, board }) => {
  const handleBuyClick = async () => {
    if (!level || !subject || !board) {
      alert("Please select level, subject, and board.");
      return;
    }

    const stripe = await stripePromise;

    try {
      const response = await axios.post(`${apiBase}/create-checkout-session`, {
        level,
        subject,
      });

      const result = await stripe.redirectToCheckout({
        sessionId: response.data.id,
      });

      if (result.error) {
        alert(result.error.message);
      }
    } catch (error) {
      console.error('Checkout error:', error);
      alert('There was an issue starting the checkout process.');
    }
  };

  return (
    <div className="w-full px-4 md:px-8 lg:px-16 my-6">
      <button
        onClick={handleBuyClick}
        className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-bold py-4 px-6 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition transform duration-200 ease-in-out text-lg"
      >
        Buy Year Planner
      </button>
    </div>
  );
};

export default BuyButton;
